import type { FrontendWidget } from '../types';
import { HeroComponent } from './HeroComponent';
import { HeroComponentB } from './HeroComponentB';
import { HeroComponentC } from './HeroComponentC';
import type { HeroConfig, HeroResolved } from './types';

export const heroWidget: FrontendWidget<HeroConfig, HeroResolved> = {
  componentType: 'widgets.hero',
  // 70.14: SlotRenderer adds no container — full-bleed: paints a background and image to the viewport edge.
  layout: 'self',
  displayName: 'Hero',
  defaultValues: { title: 'Headline' },
  ComponentA: HeroComponent,
  ComponentB: HeroComponentB,
  ComponentC: HeroComponentC,
  resolveSync: (config) => config,
};
